import { render, staticRenderFns } from "./GameButtonsGroup.vue?vue&type=template&id=6171c408&scoped=true&"
import script from "./GameButtonsGroup.vue?vue&type=script&lang=js&"
export * from "./GameButtonsGroup.vue?vue&type=script&lang=js&"
import style0 from "./GameButtonsGroup.vue?vue&type=style&index=0&id=6171c408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171c408",
  null
  
)

export default component.exports